import React from "react";
import { useSelector } from "react-redux";

// components
import { getFooterVisibility } from "frontend/store/layout";
import Socials from "./Socials";
import { NounGazetteSubscription } from "./NounGazetteSubscription";
import Flexbox from "core/Flexbox";
import TextLinks from "./TextLinks";

// styles
import colors from "core/colors";
import {
    Footer,
    SiteFooterWrapper,
    SiteFooterGrid,
    FooterRow,
    FooterCol,
    CopyrightBar,
    NounProjectLogo,
    HomeLink,
} from "./styles";

const StyledFooter = () => {
    return (
        <Footer id="site-footer" data-testid="site-footer">
            <SiteFooterWrapper fullWidth>
                <SiteFooterGrid>
                    <FooterRow>
                        <FooterCol>
                            <HomeLink href="/" alt="Home">
                                <NounProjectLogo
                                    title="Noun Project Logo"
                                    fillColor={colors.primary.diamond}
                                />
                            </HomeLink>
                            <Socials />
                        </FooterCol>
                        <FooterCol>
                            <Flexbox justifyContent="flex-end">
                                <NounGazetteSubscription />
                            </Flexbox>
                        </FooterCol>
                    </FooterRow>
                </SiteFooterGrid>
                <TextLinks />
            </SiteFooterWrapper>
            <CopyrightBar fullWidth>© Noun Project Inc.</CopyrightBar>
        </Footer>
    );
};

const SiteFooter = () => {
    const isVisible = useSelector(getFooterVisibility);
    if (!isVisible) {
        return null;
    }
    return <StyledFooter />;
};

// Default component can be used by SPA & SSR pages.
export default SiteFooter;

// Old legacy pages, like /apps/, don't have a redux store at all; so
// we return a simplified component that isn't customizable via Redux.
export const LegacySiteFooter = StyledFooter;
